import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Button, Divider } from 'semantic-ui-react';
import { FormFields } from '~/components/FormFields';
import { useTranslation } from 'react-i18next';
import { emailRegex } from '~/components/FormFields/constants';
import { RecipientWrapper } from '~/pages/Dairy/Newsletter/CreateEditNewsletter/Recipients/AdditionalRecipients/style';
import { StyledLabel } from '~/pages/Dairy/Newsletter/style';

const AddicionalRecipients: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'additionalRecipients'
  });

  function addRecipient() {
    const email = '';
    append({ email });
  }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        <StyledLabel>{t('Additional recipients')}</StyledLabel>
        <Button
          style={{ marginLeft: 5 }}
          onClick={addRecipient}
          primary
          size='mini'
          type={'button'}
          icon='plus'
        />
      </div>
      <Divider />
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
        {fields.map((recipient, recipientIndex) => (
          <RecipientWrapper key={recipient.id}>
            <FormFields.Input
              name={`additionalRecipients[${recipientIndex}].email`}
              type='text'
              key={recipient.id}
              style={{ width: 300 }}
              size='large'
              rules={{
                required: {
                  value: true,
                  message: t('Please enter email')
                },
                pattern: {
                  value: emailRegex,
                  message: t('Please enter valid email')
                }
              }}
              placeholder={t('Email')}
              control={control}
            />
            <Button
              style={{ marginLeft: 10 }}
              onClick={() => remove(recipientIndex)}
              size={'small'}
              basic
              color='red'
              type={'button'}
              icon='trash' />
          </RecipientWrapper>
        ))}
      </div>
    </>
  );
};

export default AddicionalRecipients;
